import { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { IResetPasswordProps } from '../../types/propTypes';
import { forgotPasswordChange } from '../../services/login/login-service';
import { IForgotPasswordChangeField } from '../../models/login';
import { Formik, Field } from 'formik';
import { Form, Button } from 'react-bootstrap';
import { ReactstrapFormikPasswordInput } from '../../components/reactstrap-formik';
import { ResetPassworValidationSchema } from '../../validation/login/login-validation';
import { Common } from '../../utils/constants';
import { toast } from 'react-toastify';
import { emailNotification } from '../../services/login/loginApi-service';
import images from '../../assets/images';
import { companyNameReplace } from '../../utils';
import { useTranslation } from 'react-i18next';
import OTPField from '../../components/common/OTPField';
import { showResetPasswordErrorToast } from '../../utils/authErrorToast';

const ResetPasswordForm = ({ email, onChangeStage }: IResetPasswordProps) => {
  const { t } = useTranslation();
  const strengthRef = useRef('');
  const initialState: IForgotPasswordChangeField = {
    code: '',
    password: '',
    email: '',
    confirmPassword: '',
  };

  const handleSubmit = async (value: IForgotPasswordChangeField) => {
    value.email = String(email);

    const emailNotificationInput = {
      email: email?.toLowerCase(),
      action_type: Common.passwordChangeAction.FORGOT_PASSWORD,
      while_logged_out: true,
    };

    try {
      await forgotPasswordChange(value);
      toast.success(t('forgot.toast.success'));
      await emailNotification(emailNotificationInput);
      onChangeStage(Common.AuthStage.SIGNIN);
    } catch (error) {
      showResetPasswordErrorToast(error, t);
    }
  };

  return (
    <>
      <Helmet>
        <title>{companyNameReplace(t('forgot.resetTitle'))}</title>
      </Helmet>
      <button
        type="button"
        className="btn btn-icon btn-link pr-0 btn-back"
        onClick={() => onChangeStage(Common.AuthStage.FORGOT_PASSWORD)}
        title={t<string>('forgot.button.back')}
      >
        <img className="icon" src={images.backArrowRSVG} alt={t<string>('forgot.button.back')} />
      </button>
      <div className="title-outer mb-4">
        <h1 className="title">
          <img src={images.logoIconPNG} alt={companyNameReplace(t<string>('login.label.logo'))} />
          {t('forgot.resetHeader')}
        </h1>
        <p>{t('forgot.resetSubHeader')}</p>
      </div>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        validationSchema={ResetPassworValidationSchema(t, strengthRef)}
      >
        {(props) => {
          const { handleSubmit, values, isValid } = props;

          let buttonText = t('forgot.button.save');
          let isDisabled = true;

          if (!values.code || values.code.length < 6) {
            buttonText = t('forgot.button.enterCode');
            isDisabled = true;
          } else if (!(values.password && values.confirmPassword)) {
            buttonText = t('forgot.button.enterNewPassword');
            isDisabled = true;
          } else {
            buttonText = t('forgot.button.resetPassword');
            isDisabled = !isValid;
          }
          return (
            <form className="form-secondary" onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="reset-password p-1">
                <OTPField name="code" customStyleClass="reset-password-otp" />
              </div>
              <input type="text" name="username" autoComplete="username" className="hidden-input" />
              <Field
                type="password"
                name="password"
                id="Password"
                label={t('forgot.form.password')}
                component={ReactstrapFormikPasswordInput}
                autoComplete="off"
                isShowStrengthBar={true}
                passwordStrengthRef={strengthRef}
              />
              <Field
                type="password"
                name="confirmPassword"
                id="ConfirmPassword"
                label={t('forgot.form.confirmPassword')}
                autoComplete="off"
                component={ReactstrapFormikPasswordInput}
              />
              <Form.Group className="form-group">
                <Button
                  type="submit"
                  className={`btn btn-${isDisabled ? 'secondary' : 'primary'} w-100`}
                  disabled={isDisabled}
                >
                  {buttonText}
                </Button>
              </Form.Group>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
export default ResetPasswordForm;
